"use client";
import React, { useEffect, useState } from "react";
import { FieldValues, Path, UseFormRegister } from "react-hook-form";

import Select, { Option } from "components/Select";
import { createTimeOptions } from "utils/time.util";

export const TimePicker = <T extends FieldValues>({
  initialEndValue,
  initialStartValue,
  endName,
  startName,
  register,
  onChangeStartTime,
  onChangeEndTime,
}: {
  initialStartValue?: string;
  initialEndValue?: string;
  startName?: Path<T>;
  endName?: Path<T>;
  onChangeStartTime?: (_: Option) => void;
  onChangeEndTime?: (_: Option) => void;
  register?: UseFormRegister<T>;
}) => {
  // 初期で渡された時刻をdisabledする
  const startTimeOptions = createTimeOptions();
  const endTimeOptions = createTimeOptions();

  useEffect(() => {
    startTimeOptions.map((option) => (option.disabled = option.label === initialEndValue));
    endTimeOptions.map((option) => (option.disabled = option.label === initialStartValue));

    // dependency array build errorを発生させないようにする。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [startOptions] = useState(startTimeOptions);
  const [endOptions] = useState(endTimeOptions);

  const onChangeStart = (currentOption: Option) => {
    onChangeStartTime && onChangeStartTime(currentOption);
    endOptions.map((option) => (option.disabled = option.label == currentOption.label));
  };

  const onChangeEnd = (currentOption: Option) => {
    onChangeEndTime && onChangeEndTime(currentOption);
    startOptions.map((option) => (option.disabled = option.label == currentOption.label));
  };

  return (
    <div className="flex items-center gap-1">
      <div>
        <Select
          options={startOptions}
          onChange={(option) => onChangeStart(option)}
          width="w-[100px]"
          initialValue={initialStartValue}
          allChoice={false}
          register={register}
          registerName={startName}
        />
      </div>
      {"〜"}
      <div>
        <Select
          options={endOptions}
          onChange={(option) => onChangeEnd(option)}
          width="w-[100px]"
          initialValue={initialEndValue}
          allChoice={false}
          register={register}
          registerName={endName}
        />
      </div>
    </div>
  );
};
